// extracted by mini-css-extract-plugin
export default {"reactedMembers":"px8qgI","totalComments":"Og6ADI","memberName":"GEtP90","subtitle":"eoTSoE","headerIcon":"avZGcB","diclaimerIcon":"oe0QDF"};